import { CombinedGraphQLErrors } from '@apollo/client/errors';
import { addBreadcrumb, captureException } from '@sentry/react';

/** Run an event-driven submit without changing the awaitable submitForm contract. */
export const submitFormFromEvent = async (submit: () => Promise<void>): Promise<void> => {
    try {
        await submit();
    } catch (error) {
        // The GraphQL error link already presents server validation feedback, and
        // Apollo retains the mutation error for field-level form feedback. A DOM
        // event cannot await the rejection; don't report that handled outcome twice.
        if (
            CombinedGraphQLErrors.is(error) &&
            error.errors.length > 0 &&
            error.errors.every((entry) => entry.extensions?.code === 'ValidationError')
        ) {
            addBreadcrumb({
                category: 'form.submit',
                level: 'info',
                message: 'Form submission rejected by server validation.',
            });
            return;
        }

        // Consume the event promise without hiding genuine failures from Sentry.
        captureException(error);
    }
};
